import React from "react";
import "../css/SubscribeForm.css"; // Import the CSS file

const SubscribeForm = () => {
  return (
    <div className="form-body">
      <div className="form-flex-container">
        <div className="form-description-text">
          <p>hello join the conversation here and get updates and offers as they become available</p>
        </div>
      <div className="form-container">
        <form
          action="https://kmsoundstrategies.us8.list-manage.com/subscribe/post?u=baac151c4399dde95540f77f5&amp;id=a995a252f3&amp;f_id=00d813e1f0"
          method="post"
          id="subscribe-form"
          name="subscribe-form"
          className="validate"
          target="_blank"
          noValidate
        >
          <div className="form-content">
            <h2 className="form-title">Subscribe</h2>
            <p className="form-note">
              <span className="asterisk">*</span> indicates required
            </p>
            <div className="form-field">
              <label htmlFor="email-input">
                Email Address <span className="asterisk">*</span>
              </label>
              <input
                type="email"
                name="EMAIL"
                className="input email"
                id="email-input"
                required
              />
            </div>
            <div className="form-responses">
              <div className="response error-response" id="error-response"></div>
              <div className="response success-response" id="success-response"></div>
            </div>
            <div className="hidden-input" aria-hidden="true">
              <input
                type="text"
                name="b_baac151c4399dde95540f77f5_a995a252f3"
                tabIndex="-1"
                value=""
              />
            </div>
            <div className="form-actions">
              <input
                type="submit"
                name="subscribe"
                id="subscribe-button"
                className="button"
                value="Subscribe"
              />
            </div>
          </div>
        </form>
      </div>

      </div>
      
    </div>
  );
};

export default SubscribeForm;
